var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchivedMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2C6.03043 2 6.53914 2.21071 6.91421 2.58579C7.28929 2.96086 7.5 3.46957 7.5 4C7.5 4.53043 7.28929 5.03914 6.91421 5.41421C6.53914 5.78929 6.03043 6 5.5 6C4.96957 6 4.46086 5.78929 4.08579 5.41421C3.71071 5.03914 3.5 4.53043 3.5 4C3.5 3.46957 3.71071 2.96086 4.08579 2.58579C4.46086 2.21071 4.96957 2 5.5 2ZM5.5 3C5.23478 3 4.98043 3.10536 4.79289 3.29289C4.60536 3.48043 4.5 3.73478 4.5 4C4.5 4.26522 4.60536 4.51957 4.79289 4.70711C4.98043 4.89464 5.23478 5 5.5 5C5.76522 5 6.01957 4.89464 6.20711 4.70711C6.39464 4.51957 6.5 4.26522 6.5 4C6.5 3.73478 6.39464 3.48043 6.20711 3.29289C6.01957 3.10536 5.76522 3 5.5 3ZM5.5 6.5C5.84 6.5 6.25 6.545 6.705 6.63L5.87 7.465L5.5 7.45C4.015 7.45 2.45 8.18 2.45 8.5V9.05H5.55L6.5 10H1.5V8.5C1.5 7.17 4.165 6.5 5.5 6.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 10H7.22222V7.55556H7.97917V9.20312H9.99479V7.55556H10.7778V10ZM7 6H11V7.33333H7V6ZM8.44444 7.77778H9.55556C9.61778 7.77778 9.66667 7.82667 9.66667 7.88889V8.66667H8.33333V7.88889C8.33333 7.82667 8.38222 7.77778 8.44444 7.77778ZM7.44444 6.55208V6.75H10.5556V6.55208H7.44444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedMembers);
export default __webpack_public_path__ + "static/media/archivedMembers.e88e215d.svg";
export { ForwardRef as ReactComponent };